var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.1 17.6",
    style: {
      enableBackground: "new 0 0 17.1 17.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#788195;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.4,4.6C0.4,4.6,0.4,4.6,0.4,4.6c0.2-0.5,0.5-0.8,1.1-0.8c1.3,0,2.5,0,3.8,0c0.1,0,0.1,0,0.2,0 c0-0.2,0-0.3,0.1-0.5C5.7,2.1,6.8,1,8.2,0.8c0.6-0.1,1.2,0.1,1.7,0.4c0.9,0.5,1.4,1.3,1.6,2.3c0,0.1,0,0.2,0,0.3c0.1,0,0.1,0,0.2,0 c1.3,0,2.6,0,3.8,0c0.5,0,0.9,0.4,1,0.9c0.1,0.5-0.2,0.9-0.7,1.1c-0.1,0-0.2,0-0.4,0c-3.5,0-7.1,0-10.6,0c-0.1,0-0.1,0-0.2,0 c0,0.3,0.1,0.6,0.1,1C4.8,7.9,5,9.1,5.1,10.2c0.1,1,0.2,2,0.4,2.9c0.1,1,0.7,1.6,1.7,1.6c0.8,0.1,1.6,0,2.4,0 c0.9-0.1,1.5-0.7,1.7-1.7c0.2-1.8,0.5-3.6,0.7-5.4c0.1-0.5,0.5-0.9,0.9-0.9c0.5,0,0.9,0.3,1,0.8c0,0.2,0,0.4,0,0.6 c-0.2,1.4-0.4,2.9-0.6,4.3c-0.1,0.6-0.1,1.2-0.4,1.8c-0.7,1.4-1.8,2.2-3.3,2.5c0,0-0.1,0-0.1,0c-0.8,0-1.6,0-2.4,0c0,0,0,0-0.1,0 c-0.8-0.1-1.4-0.4-2-0.9c-0.8-0.7-1.4-1.5-1.6-2.6c-0.1-0.8-0.2-1.6-0.3-2.4C3,9.6,2.8,8.2,2.6,6.8c0-0.3-0.1-0.6-0.1-0.9 c0,0,0,0,0,0c-0.4,0-0.7,0-1.1,0c-0.4,0-0.8-0.3-1-0.7c0,0,0-0.1,0-0.1C0.4,4.9,0.4,4.8,0.4,4.6z M9.4,3.8c0.1-0.6-0.3-0.9-0.8-1 c-0.1,0-0.2,0-0.3,0c-0.6,0-0.9,0.4-0.8,1C8.1,3.8,8.7,3.8,9.4,3.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02Icon);
export default __webpack_public_path__ + "static/media/02-icon.820a34861ab9ef6c099a3562ddd558cf.svg";
export { ForwardRef as ReactComponent };